import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    viewTitle: '',
    menuList: [],
    summaryMessage: {},
    expandBanner: false,
    currentKinoId: 0,
    notificationCount: 0,
    systemNotificationCount: 0,
    adminNotificationCount: 0,
    carNotificationCount: 0,
    licenceNotificationCount: 0
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
